<template>
    <v-app>
        <portal-sysbar></portal-sysbar>
        <div class="main-content">
            <portal-aside></portal-aside>
            <portal-title
            :title="$t('message.aside.krefeldplan', { value: 'default' })"
            ></portal-title>
            <portal-breadcumb></portal-breadcumb>

            <div class="content">

                <v-flex d-flex>
                    <v-layout wrap>
                        <v-flex md5 v-for="item in documents" :key="item.id">
                            <v-card class="card-container">
                                <a target="_blank" :href="item.link">
                                    <img :src="item.img">
                                    <v-divider></v-divider>
                                    <div class="desc">{{ item.desc }}</div>
                                </a>
                                
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>
                
                <v-row class="mt-4">
                    <v-col class="d-flex" cols="12" sm="2" offset="9">
                        <div>
                        <v-btn class="ma-2 pa-2" @click="backToKrefeldPlan()" color="#00475A" block dark type="submit">
                            Zurück nach krefeld plan
                        </v-btn>
                        </div>
                    </v-col>
                   
                </v-row>
            
            </div>
        </div>
    </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import { mapGetters } from "vuex";
export default {
    name: "KrefeldDocuments",
     data() {
        return {
            documents: [
                {
                    link:"/static/krefeld-docs/Nutzungsbedingungen_Allgemeiner_Teil_AT_ 2018.pdf",
                    img:"/static/krefeld-imgs/516.jpg",
                    desc:"Nutzungsbedingungen allgemeiner Teil"
                },
                {
                    link:"/static/krefeld-docs/bt_2015.pdf",
                    img:"/static/krefeld-imgs/517.jpg",
                    desc:"Nutzungsbedingungen besonderer Teil"
                },
                {
                    link:"/static/krefeld-docs/2023-01-16 Preisliste BWK 2023.pdf",
                    img:"/static/krefeld-imgs/519.jpg",
                    desc:"Preisliste"
                },
                {
                    link:"/static/krefeld-docs/Antrag_auf_Nutzung_der_Serviceeinrichtung_2017.pdf",
                    img:"/static/krefeld-imgs/518.jpg",
                    desc:"Antrag auf Nutzung der Serviceeinrichtung"
                },
                {
                    link:"/static/krefeld-docs/Gleisplan_Bw_2015.pdf",
                    img:"/static/krefeld-imgs/511.png",
                    desc:"Gleisplan Bw Krefeld"
                },
                {
                    link:"/static/krefeld-docs/KKR_DB_Kopie.gif",
                    img:"/static/krefeld-imgs/512.jpg",
                    desc:"Gleisplan Krefeld Hbf"
                }
            ]
        };
    },

    mounted() {
        this.isAuthorized();
        this.getLastPlan();
    },

    computed: {
    ...mapGetters("auth", {
      getterFunctionnalities: "getFunctionnalities",
    }),
  },


    methods: {
        isAuthorized() {
            if (this.getterFunctionnalities.includes("krefeldadmin")) {
                this.auth = {
                    krefeldplan: true
                };
            }
        },

        backToKrefeldPlan() {
            this.$router.push("/krefeldplan");
        },

    },
    
    components: {
        PortalSysbar,
        PortalAside,
        PortalTitle,
        PortalBreadcumb,

    },
};

</script>
<style scoped>

.card-container {
    overflow: hidden;
}

.card-container img{
    margin: 10px;
    padding: 5px;
    object-fit: contain;
    height: 280px;
    width: 260px;
  }

  .layout.wrap{
    gap: 25px;
  }

  .flex.md5{
    flex-basis: 260px;
  }

  .desc{
    color: white;
    padding: 5px 0px 8px 0px;
    background-color: #385F73;
  }

  .card-container a{
    text-decoration: none;
    color: black;
    display: block;
    text-align: center;
  }
</style>
